// recursively delete empty fields in a given object.
export function removeEmptyFields(obj) {
    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'string') {
            // Trim string values
            obj[key] = obj[key].trim();
        }

        if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key]) && !(obj[key] instanceof Date)) {
            // Recursively clean nested objects
            removeEmptyFields(obj[key]);

            // Remove empty objects after recursion
            if (Object.keys(obj[key]).length === 0) {
                delete obj[key];
            }
        } else if (
            obj[key] == null ||
            typeof obj[key] === 'undefined' ||
            obj[key] === '' ||
            (Array.isArray(obj[key]) && obj[key].length === 0) ||
            (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0 && !(obj[key] instanceof Date))

        ) {
            delete obj[key];
        }
    });
    // Object.keys(obj).forEach(key => {
    //     if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
    //         removeEmptyFields(obj[key]);
    //     } else if (obj[key] === null || typeof obj[key] === 'undefined' || obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length === 0)) {
    //         delete obj[key];
    //     }
    // });
}

export function removeEmptyReturn<T>(obj: T) {
    removeEmptyFields(obj);
    return obj;
}
